import React, { forwardRef } from 'react'

interface CardProps {
  children: React.ReactNode
  className?: string
  padding?: 'none' | 'sm' | 'md' | 'lg'
  elevated?: boolean
}

const paddingStyles = {
  none: '',
  sm: 'p-4',
  md: 'px-4 py-5 sm:p-6',
  lg: 'p-6 sm:p-8',
}

export const Card = forwardRef<HTMLDivElement, CardProps>(({
  children,
  className = '',
  padding = 'md',
  elevated = false,
}, ref) => {
  return (
    <div
      ref={ref}
      className={`
        bg-surface rounded
        ${elevated ? 'shadow-md' : 'shadow-sm border border-border'}
        ${paddingStyles[padding]}
        ${className}
      `}
    >
      {children}
    </div>
  )
})

Card.displayName = 'Card'

interface CardHeaderProps {
  title: string
  action?: React.ReactNode
  subtitle?: string
}

export const CardHeader: React.FC<CardHeaderProps> = ({ title, subtitle, action }) => {
  return (
    <div className="flex items-center justify-between mb-4">
      <div>
        <h3 className="text-lg font-semibold text-foreground">{title}</h3>
        {subtitle && <p className="mt-1 text-sm text-foreground-muted">{subtitle}</p>}
      </div>
      {action && <div>{action}</div>}
    </div>
  )
}
